import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import QuoteWizardNavigation from './components/QuoteWizardNavigation';
import { II18nMessages } from '../../../../services/branding/models';
import { withRouter } from 'react-router';
import { flow, forEach } from 'lodash';
import { IHeaderActions } from './models';
import { actions as quoteActions } from '../../../../services/quote/reducer';
import { actions as headerActions } from './reducer';
import { IChannel } from '../../../../data/api/models';
import { destroy } from 'redux-form';
import { IQuoteActions, IQuoteState } from '../../../../services/quote/models';
import { push } from 'react-router-redux';
import { IStore } from '../../../../redux/IStore';
import { IAuthState } from '../../../../services/auth/models';
import { Nav, Navbar, NavItem } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import * as Commonmark from 'react-commonmark';
import {Link} from 'react-router-dom';

interface IHeaderProps {
  classes: any;
  isDrawerOpened: boolean;
  i18n: II18nMessages;
  auth: IAuthState;
  actions: {
    push: (route: string) => void;
    header: IHeaderActions;
    quote: IQuoteActions;
    destroy(formName: string);
  };
  steps: object;
  location: any;
  channel: IChannel;
  quote: IQuoteState;
}

interface IHeadersStates {
  openMenu: boolean;
}

class Header extends React.Component<IHeaderProps, IHeadersStates> {
  public state = {
    openMenu: false,
  };

  private renderAdditionalLogo = () => {
    const {channel} = this.props;

    if (!channel.additionalLogo) {
      return null;
    }

    return (
      <div className="additional-logo-container">
        <img src={channel.additionalLogo} alt={channel.key}/>
      </div>
    );
  }

  private renderWelcomeMessage = () => {
      const { channel } = this.props;
      if (!channel.products[0].metadata.welcome_message) {
        return null;
      }
      const welcomeMessage = channel.products[0].metadata.welcome_message;
      return (
        <Commonmark
          source={welcomeMessage}
        />
      );
  }

  private openMenu = (value: boolean) => () => {
    this.setState({
      openMenu: false,
    });
    if (value === false) {
      this.setState({
        openMenu: true,
      });
    }
  }

  private renderBanner = () => {
    const {channel} = this.props;
    const { openMenu } = this.state;
    let logoSrc = null;
    let logoSmallSrc = null;
    let logoAlt = null;
    let houseIcon = null;
    let newIcon = null;
    let navClass = null;
    let logoLink = null;

    if (channel.key === 'dia-b2c') {
      logoSrc = require('./img/diabetes_logo.png');
      logoSmallSrc = require('./img/diabetes_logo.png');
      logoAlt = 'Diabetes';
      houseIcon = require('./img/IconHome-white.png');
      newIcon = require('./img/new-trans.png');

      return (
          <div className="navbar" role="navigation">
            <div className="top">
              <a className="navbar-brand" href="http://www.diabetes.co.uk/">
                <img className="logo" src={logoSmallSrc} alt={logoAlt}/>
              </a>
              <div className="row">
                <ul id="topmenu" className="nav navbar-nav nav-header">
                  <li><a href="http://www.diabetes.co.uk/diabetes-forum/">Forum<span
                      className="caret"/></a></li>
                  <li><a href="http://www.diabetes.co.uk/diabetes-symptoms.html">Symptoms</a></li>
                  <li><a href="http://www.diabetes.co.uk/newly-diagnosed.html">Newly Diagnosed</a></li>
                  <li><a href="http://www.diabetes.co.uk/having-diabetes.html">Have Diabetes</a></li>
                  <li><a href="http://www.diabetes.co.uk/diabetes-and-parenting.html">Parents</a></li>
                  <li><a href="http://www.diabetes.co.uk/Diabetes-and-the-family.html">Family + Care</a></li>
                </ul>
              </div>

              <div className="navbar-header-md row">
                <button className="navbar-toggle-md" onClick={this.openMenu(openMenu)}>
                  <span className="icon-bar"/>
                  <span className="icon-bar"/>
                  <span className="icon-bar"/>
                  {openMenu && (
                    <ul className="menu-top" >
                      <li className="home-md">
                        <a href="http://www.diabetes.co.uk/" className="menu-button" title="Home">
                          <span className="menu-label">Home</span>
                        </a>
                      </li>
                      <li className="home-lg">
                        <a href="http://www.diabetes.co.uk/" className="menu-button" title="Home">
                          <span className="menu-label">
                            <img src="../assets/images/IconHome-white.png" alt="Home" />
                          </span>
                        </a>
                      </li>
                      <li>
                        <a href="http://www.diabetes.co.uk/pre-diabetes.html"
                           className="menu-button" title="Prediabetes"
                        >
                          <span className="menu-label">Prediabetes</span>
                        </a>
                      </li>
                      <li>
                        <a href="http://www.diabetes.co.uk/type1-diabetes.html" className="menu-button" title="Type 1">
                          <span className="menu-label">Type 1</span>
                        </a>
                      </li>
                      <li>
                        <a href="http://www.diabetes.co.uk/type2-diabetes.html" className="menu-button" title="Type 2">
                          <span className="menu-label">Type 2</span>
                        </a>
                      </li>
                      <li>
                        <a href="http://www.diabetes.co.uk/food-and-recipes.html" className="menu-button"
                           title="Food + Recipes">
                          <span className="menu-label">Food + Recipes</span>
                        </a>
                      </li>
                      <li>
                        <a href="http://www.diabetes.co.uk/diabetes-and-life.html" className="menu-button"
                             title="Living with diabetes">
                          <span className="menu-label">Living with diabetes</span>
                        </a>
                      </li>
                      <li>
                        <a href="http://www.diabetes.co.uk/treatment.html" className="menu-button" title="Treatment">
                          <span className="menu-label">Treatment</span>
                        </a>
                      </li>
                      <li>
                        <a href="http://www.diabetes.co.uk/diabetes-complications/diabetes-complications.html"
                             className="menu-button" title="Complications of diabetes">
                            <span className="menu-label">Complications</span>
                        </a>
                      </li>
                      <li className="selected">
                        <a href="http://www.diabetes.co.uk/finance.html" className="menu-button"
                           title="Finance and Insurance">
                          <span className="menu-label">Insurance</span>
                        </a>
                      </li>
                      <li>
                        <a href="http://www.diabetes.co.uk/shop/" className="menu-button" title="Shop">
                          <span className="menu-label">Shop</span>
                        </a>
                        <div className="imgnew">
                          <img src="../assets/images/new-trans.png" width="29" height="15" />
                        </div>
                      </li>
                      <li className="menu-right">
                        <a href="#" className="menu-button menu-drop">
                          <span className="menu-label">Explore</span>
                        </a>
                      </li>
                    </ul>
                  )}
                </button>
              </div>

              <div id="menumain">
                <div id="menu4">
                  <ul className="menu-top">
                    <li className="home-md"><a href="http://www.diabetes.co.uk/" className="menu-button"
                                               title="Home"><span className="menu-label">Home</span></a></li>
                    <li className="home-lg"><a href="http://www.diabetes.co.uk/" className="menu-button"
                                               title="Home"><span className="menu-label"><img
                        src={houseIcon} alt="Home"/></span></a></li>
                    <li><a href="http://www.diabetes.co.uk/pre-diabetes.html" className="menu-button"
                           title="Prediabetes"><span className="menu-label">Prediabetes</span></a></li>
                    <li><a href="http://www.diabetes.co.uk/type1-diabetes.html" className="menu-button"
                           title="Type 1"><span className="menu-label">Type 1</span></a></li>
                    <li><a href="http://www.diabetes.co.uk/type2-diabetes.html" className="menu-button"
                           title="Type 2"><span className="menu-label">Type 2</span></a></li>
                    <li><a href="http://www.diabetes.co.uk/food-and-recipes.html" className="menu-button"
                           title="Food + Recipes"><span className="menu-label">Food + Recipes</span></a></li>
                    <li><a href="http://www.diabetes.co.uk/diabetes-and-life.html" className="menu-button"
                           title="Living with diabetes"><span className="menu-label">Living with diabetes</span></a>
                    </li>
                    <li><a href="http://www.diabetes.co.uk/treatment.html" className="menu-button"
                           title="Treatment"><span className="menu-label">Treatment</span></a></li>
                    <li><a
                        href="http://www.diabetes.co.uk/diabetes-complications/diabetes-complications.html"
                        className="menu-button" title="Complications of diabetes"><span
                        className="menu-label">Complications</span></a></li>
                    <li className="selected"><a href="http://www.diabetes.co.uk/finance.html"
                                                className="menu-button" title="Finance and Insurance"><span
                        className="menu-label">Insurance</span></a></li>
                    <li><a href="http://www.diabetes.co.uk/shop/" className="menu-button" title="Shop"><span
                        className="menu-label">Shop</span></a>
                      <div className="imgnew"><img src={newIcon} width="29" height="15"/></div>
                    </li>
                    <li className="menu-right"><a href="#" className="menu-button menu-drop"><span
                        className="menu-label">Explore</span></a></li>
                  </ul>
                </div>
              </div>
              <div id="menu4" style={{
                width: '96px',
                float: 'right',
                top: '62px',
                paddingLeft: '21px',
                marginRight: '16px',
              }}>
                <ul className="menu-top">
                  <li><Link to="/auth/login" className="menu-button" title="Login"><span
                      className="menu-label">Login</span></Link>
                  </li>
                </ul>
              </div>
            </div>
            <div id="aroundcrumb">
              <div className="breadCrumbHolder module">
                <div id="breadcrumb" className="breadCrumb module" itemProp="breadcrumb">
                  <ul>
                    <li className="first">
                      <a href="http://www.diabetes.co.uk/index.html"/>
                    </li>
                    <li>
                      <a href="http://www.diabetes.co.uk/finance.html">Diabetes Insurance and Finance</a>
                    </li>
                    <li className="last">Diabetic Travel Insurance</li>
                  </ul>
                </div>
              </div>
            </div>

            <div id="topmenu-md" className="row">
              <a href="http://www.diabetes.co.uk/diabetes-forum/" className="col-sm-2">Forum</a>
              <a href="http://www.diabetes.co.uk/diabetes-symptoms.html" className="col-sm-2">Symptoms</a>
              <a href="http://www.diabetes.co.uk/newly-diagnosed.html" className="col-sm-2">Newly
                Diagnosed</a>
              <a href="http://www.diabetes.co.uk/having-diabetes.html" className="col-sm-2">Have Diabetes</a>
              <a href="http://www.diabetes.co.uk/diabetes-and-parenting.html"
                 className="col-sm-2">Parents</a>
              <a href="http://www.diabetes.co.uk/Diabetes-and-the-family.html" className="col-sm-2">Family +
                Care</a>
            </div>
          </div>
      );
    } else {
      if (channel.key === 'adv-b2c') {
        logoSmallSrc = require('./img/adventures_logo.png');
        logoAlt = 'Adventures';
        navClass = 'navbar-brand';
        logoLink = 'https://www.pjhayman.com/products/adventures/';
      }

      if (channel.key === 'pst-b2c') {
        logoSmallSrc = require('./img/sports_travel_logo.png');
        logoAlt = 'Sports Travel';
        navClass = 'navbar-brand-pst';
        logoLink = 'https://quote.sporttravelinsurance.co.uk/';
      }

      if (channel.key === 'cps-b2c') {
        logoSmallSrc = require('./img/coach_plus_logo.jpg');
        logoAlt = 'Coach Plus';
        navClass = 'navbar-brand-cps';
        logoLink = 'https://quote.coachplusinsurance.co.uk/';
      }

      if (channel.key === 'eurp-b2c') {
        logoSmallSrc = require('./img/euro_plus.png');
        logoAlt = 'Euro Plus';
        navClass = 'navbar-brand';
        logoLink = 'https://quote.europluscover.co.uk/';
      }

      return (
        <div className="logo-agg-container">
          <a className={navClass} href={logoLink}>
            <img className="logo" src={logoSmallSrc} alt={logoAlt} style={{ width: '295px' }} />
          </a>
        </div>
      );
    }
  }

  private renderLinks = () => {
    const {channel, auth, location } = this.props;
    const isInAuthArea = location.pathname.match(/(auth)/);

    if (channel.channelType === 'AGG') {
      return null;
    }

    let showGetQuoteLink = true;
    if (channel.key === 'eurp-b2c') {
      showGetQuoteLink = false;
    }

    return (
      <div>
        <Navbar collapseOnSelect={true}>
          <Navbar.Header>
            <Navbar.Toggle/>
          </Navbar.Header>
          <Navbar.Collapse>
            <Nav pullRight={true} className="links">
              {isInAuthArea && !auth.isAuthenticated ? (
                  <>
                    {showGetQuoteLink ? (
                      <LinkContainer to="/" exact={true}>
                        <NavItem eventKey={1}>
                          GET A QUOTE
                        </NavItem>
                      </LinkContainer>
                    ) : (null)}
                  </>
              ) : (
                <LinkContainer to={auth.isAuthenticated ? '/account/summary' : '/auth/login'} exact={true}>
                  <NavItem
                    eventKey={1}
                    href={auth.isAuthenticated ? '/account/summary' : '/auth/login'}
                  >
                    {auth.isAuthenticated ? 'MY ACCOUNT' : 'LOGIN'}
                  </NavItem>
                </LinkContainer>
              )}
              <NavItem
                eventKey={2}
                href={channel.urls.aboutUs}
                target="_blank"
                disabled={false}>
                ABOUT US
              </NavItem>
              <NavItem eventKey={3} href={channel.urls.contactUs} target="_blank" disabled={false}>
                CONTACT
              </NavItem>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </div>
    );
  }

  private renderWizardNavigation = () => {
    const {steps, location, i18n, channel} = this.props;

    let currentStep = '';
    let isInQuoteProcess = false;

    forEach(steps, (step) => {
      if (step.route === location.pathname) {
        currentStep = step.key;
        isInQuoteProcess = true;
      }
    });

    if (isInQuoteProcess) {
      return (
        <QuoteWizardNavigation i18n={i18n} steps={steps} currentStep={currentStep} channel={channel} />
      );
    }
  }

  public render() {
    const { channel, quote, location } = this.props;
    const hasAggError = quote.aggError;

    let classes = '';

    if (channel.channelType === 'AGG') {
      classes += ' aggregator';
    }

    if (channel.key === 'dia-b2c') {
      return (
        <header className={classes} style={{ minHeight: '175px' }}>
          <div className="container dia-header-height">
            {this.renderBanner()}
          </div>
          {location.pathname === '/trip-details' && (
            <div className="container welcome-message">
              {this.renderWelcomeMessage()}
            </div>
          )}
          {!hasAggError && (
            <div className="">
              {this.renderWizardNavigation()}
            </div>
          )}
        </header>
      );
    } else {
      return (
        <header className={classes}>
          {this.renderLinks()}
         <div className="container">
            <div className="header-container">
              {this.renderBanner()}
              {!hasAggError && (
                <div className="more-info-container">
                  <div className="phone">
                    {channel.phone}
                  </div>
                  <div className="opening-hours">
                    {channel.openingHours}
                  </div>
                </div>
              )}
            </div>
          </div>
          {!hasAggError && (
              <div className="wizard-container">
                {this.renderWizardNavigation()}
              </div>
          )}
        </header>
      );
    }
  }
}

export default flow([
  connect(
    (state: IStore) => ({
      isDrawerOpened: state.header.isDrawerOpened,
      i18n: state.branding.i18n,
      channel: state.branding.channel,
      auth: state.auth,
      quote: state.quote,
    }),
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
        header: bindActionCreators({...headerActions}, dispatch),
        destroy: bindActionCreators(destroy, dispatch),
        quote: bindActionCreators({...quoteActions}, dispatch),
      },
    }),
  ),
  withRouter,
])(Header);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Shell/scenes/Header/index.tsx